<h1
  class="font-weight-boldest text-dark-75 mt-15"
  style="font-size: 3rem; text-align: center"
>
  Unsubscribe
</h1>
<ng-container *ngIf="isSub && !isLoading" >
<p
  class="font-size-h3 text-muted font-weight-normal mt-5"
  style="text-align: center"
>
  You will not recive any more emails from trGate store
</p>
<div style="text-align: center">
  <button (click)="unsubscribe()" class="btn btn-primary mt-5">Unsubscribe</button>
</div>
</ng-container>
<ng-container *ngIf="!isSub && !isLoading">
    <p
  class="font-size-h3 text-muted font-weight-normal"
  style="text-align: center"
>
  You Are Unsubscribed
</p>
</ng-container>
<app-spinner *ngIf="isLoading"></app-spinner>
